<div class="gallery-container">
  <h2 class="gallery-title">Gallery content</h2>
  
  <div class="gallery-images-container">
    <h3>Gallery images</h3>
    <div class="gallery-images">
      <div class="image-preview" *ngFor="let file of feature.value; let i = index">
        <img [src]="file.url | safeResourceUrl" alt="Uploaded file">
        <button class="delete-button" (click)="deleteFile(i)">
          <i class="pi pi-trash"></i>
        </button>
      </div>
    </div>
    <div class="drag-indicator">
      <span class="arrow">←</span> <span class="arrow">→</span> Drag images to reorder
    </div>
  </div>
  
  <div class="dropzone file-upload-container" appDnd (fileDropped)="onFileDropped($event)">
    <input type="file" #fileDropRef id="fileDropRef" multiple
           (change)="fileBrowseHandler($event)" accept="image/*"
           [attr.maxFileSize]="maxImageSize" />
    <p>Drag and drop your file(s) here</p>
    <p>or</p>
    <label for="fileDropRef" class="browse-link">Browse by clicking here</label>
    <p class="file-info">Compatible formats : jpeg, png, jpg. Limit of 2 mb</p>
    <p class="file-info">12 images max.</p>
  </div>
</div>